export default __webpack_public_path__ + "static/media/2t2team.039879a7.jpg";